function openSmallBenefitCard(id) {
  const clonedCardId = `${id}-clone`;

  if (document.getElementById(clonedCardId)) return;

  const card = document.getElementById(id);
  const clonedCard = card.cloneNode(true);

  clonedCard.id = clonedCardId;
  clonedCard.classList.add("small-benefit-card--open");

  const wrapper = clonedCard.querySelector(
    ".small-benefit-card__inner-wrapper",
  );
  const closeButtonWrapper = clonedCard.querySelector(
    ".small-benefit-card__close-button-sticky-wrapper",
  );

  clonedCard
    .querySelector(".small-benefit-card__close-button")
    .addEventListener("click", (event) => {
      closeSmallBenefitCard(clonedCardId);
      event.stopPropagation();
    });

  clonedCard.addEventListener("click", function (event) {
    const benefitCardOpenModal = this.querySelector(
      ".small-benefit-card--open .small-benefit-card",
    );
    if (!benefitCardOpenModal) return;
    const clickOccurredWithinModal = benefitCardOpenModal.contains(
      event.target,
    );
    if (!clickOccurredWithinModal) {
      closeSmallBenefitCard(this.id);
    }
  });

  // Optionally, add the cloned element to the DOM
  document.body.appendChild(clonedCard);

  // Wait for the DOM to render
  requestAnimationFrame(() => {
    // This is a hack to make the modal button become sticky when it's scrollable
    closeButtonWrapper.style.height = `${wrapper.scrollHeight}px`;
  });

  const scrollBarWidth =
    window.innerWidth - document.documentElement.clientWidth;
  document.body.style.paddingRight = `${scrollBarWidth}px`;
  document.body.classList.add("no-scroll");
}

function closeSmallBenefitCard(id) {
  document.body.style.paddingRight = "";
  document.body.classList.remove("no-scroll");
  if (!id || !id.includes("clone")) {
    console.error("trying to close a non existing or closed modal");
    return;
  }
  document.getElementById(id)?.remove();
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".small-benefit-card").forEach(function (card) {
    card.addEventListener("click", function () {
      openSmallBenefitCard(this.closest(".small-benefit-card__wrapper").id);
    });
  });
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    const openModal = document.querySelector(".small-benefit-card--open");
    if (openModal) {
      closeSmallBenefitCard(openModal.id);
    }
  }
});
